import { createContext } from 'react'

export interface ZipCodeContextState {
  zipCode?: string
  updateZipCode: (val: string | undefined) => Promise<boolean>
  isZipcodeModalOpen: boolean
  openZipcodeModal: (val: boolean) => void
}

const ZipCodeContext = createContext<ZipCodeContextState>({
  updateZipCode: () => Promise.resolve(true),
  isZipcodeModalOpen: false,
  openZipcodeModal: () => undefined,
})

ZipCodeContext.displayName = 'Zip Code Context'

export default ZipCodeContext
